import { Injectable, Injector } from '@angular/core';
import { ApplicationType, PeopleApplicationServiceProxy } from '@shared/service-proxies/service-proxies';
import { AppComponentBase } from '@shared/common/app-component-base';
import { CodeService } from '../common/code/code.service';

@Injectable()
export class PeopleApplicationService extends AppComponentBase  {

    peopleApplicationTypes = [
        ApplicationType.Lia, ApplicationType.LiaRen, ApplicationType.Lia90Days, ApplicationType.LiaAndEhc,
        ApplicationType.Ehc, ApplicationType.EhcRen, //ApplicationType.Ehc90Days, // Not permitted for AG
        ApplicationType.Slap, ApplicationType.SlapRen,
        ApplicationType.Rla,
        ApplicationType.Tla,
        ApplicationType.Alap,
        ApplicationType.Abo,
        ApplicationType.Sub,
        ApplicationType.Cogs,
        ApplicationType.Npbo,
        ApplicationType.Ndn,
        ApplicationType.Npf] as const;
    eligibleTypes = [];

    constructor(
        injector: Injector,
        private codeService: CodeService,
        private peopleApplicationServiceProxy: PeopleApplicationServiceProxy
    ) {
        super(injector);
        this.peopleApplicationServiceProxy.getApplicationTypes().subscribe(types => {
            this.eligibleTypes = types;
        });

    }

    getPeopleApplications(filter: string, sorting: string, maxResultCount: number, skipCount: number) {
        return this.peopleApplicationServiceProxy.getPeopleApplications(filter, sorting, maxResultCount, skipCount);
    }

    getProfessions() {
        return this.peopleApplicationServiceProxy.getProfessions();
    }

    getPeopleApplicationTypes() {
        return this.peopleApplicationServiceProxy.getApplicationTypes();
    }
}
